// src/pages/FoerderProgrammeView.tsx
import { Box, Container, Typography } from '@mui/material';
import React, { FC } from 'react';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import MUIAlert from '../../../../components/ui-component/mui-alert/MUIAlert';
import { useFetchFoerderProgramm } from '../../../../hooks/FetchFoerderProgramm';
import FoerderProgrammGrid from './structure/FoerdProgrammGrid';

const FoerderProgrammeView: FC = () => {
	const { loading, data, error } = useFetchFoerderProgramm();

	if (error) {
		return <MUIAlert infoType={'error'} message={'Etwas ist schief gelaufen. Bitte laden Sie die Seite neue.'} />;
	}

	return (
		<Container>
			<ProgramTitleSection />

			<LoadingBackdrop open={loading} />

			<Box sx={{ mt: '2rem' }}>
				<FoerderProgrammGrid data={data} />
			</Box>
		</Container>
	);
};

const ProgramTitleSection: FC<{}> = () => {
	return (
		<>
			<Typography variant='h3' component={'h2'}>
				Kooperationsprogramme "Musische Bildung für alle"
			</Typography>
			<br />
			<Typography variant='h6' component={'h3'}>
				Hier finden Sie Informationen und programmspezifische Unterlagen (z.B. Stundenlisten etc.)  zum jeweiligen Kooperationsprogramm.
			</Typography>
		</>
	);
};

export default FoerderProgrammeView;
